import React from "react";
import PropTypes from "prop-types";

import Modal from "components/Modal";

export const ContainerVariant = {
  MODAL: "modal",
  DIV: "div",
};

export const WithContainerSection = (ModalComponent, className) => {
  const ContainerSection = ({ variant, children, ...props }) => {
    switch (variant) {
      case ContainerVariant.MODAL:
        return <ModalComponent {...props}>{children}</ModalComponent>;
      case ContainerVariant.DIV:
      default:
        return (
          <div {...props} className={className}>
            {children}
          </div>
        );
    }
  };

  ContainerSection.propTypes = {
    variant: PropTypes.oneOf(Object.values(ContainerVariant)),
    children: PropTypes.node,
  };

  ContainerSection.defaultProps = {
    variant: ContainerVariant.MODAL,
    children: undefined,
  };

  return ContainerSection;
};

const AddUserContainer = {
  Header: WithContainerSection(Modal.Header, "add-user-header"),
  Body: WithContainerSection(Modal.Body, "add-user-body"),
  Footer: WithContainerSection(Modal.Footer, "add-user-footer"),
};

export default AddUserContainer;
